import { memo } from 'react'
import { CTCGlobalIcon } from './icons/CTCGlobalIcon'
import { GraduationCapIcon } from './icons/GraduationCapIcon'
import { InstitutionIcon } from './icons/InstitutionIcon'

const parallaxStyle = (speed: number) => ({
  transform: `translateY(calc(var(--scroll-y, 0) * ${speed} * 1px)) translateX(calc(var(--mouse-x, 0) * 0.5px))`,
})

const ABOUT_PARALLAX_STYLE = parallaxStyle(-0.03)

export const About = memo(function About() {
  return (
<section id="about" className="section-islands about-islands">
  <div className="container-islands">
    <div className="island about-island" style={ABOUT_PARALLAX_STYLE}>
      <div className="island-header">
        <span className="island-label">About Me</span>
        <h2 className="island-title">Engineering Excellence</h2>
      </div>

      <div className="about-grid-islands">
        <div className="about-text-islands">
          <p className="text-lead">
            Full-stack engineer with 11 years shipping secure, data-intensive products;
            currently founding engineer and lead architect of GridVista at CTC Global, a NERC
            CIP-aligned, multi-tenant SaaS platform streaming fiber-optic grid telemetry to
            utility operators in near real time. Own every layer: React/TypeScript front end,
            serverless APIs, GCP infrastructure, data pipeline, CI/CD, and the regulatory
            security model. Deep in zero-trust authorization, JWT/OIDC identity,
            audit-evidence design, cloud cost architecture, and real-time time-series
            visualization.
          </p>
          <p>
            My journey spans leading engineering teams at one of the world's most innovative
            companies to building high-impact solutions for global enterprises. I bring deep
            technical expertise combined with product thinking and business acumen.
          </p>
          <p>
            Whether architecting cloud-native microservices, building intuitive interfaces, or
            implementing ML pipelines, I'm passionate about solving complex problems and
            delivering exceptional value to millions of users.
          </p>
        </div>

        <div className="about-credentials-islands">
          <div className="credential-card-islands">
            <div className="credential-icon-islands">
              <CTCGlobalIcon />
            </div>
            <div className="credential-info">
              <div className="credential-title">CTC Global</div>
              <div className="credential-subtitle">Founding Engineer &amp; Technical Lead</div>
            </div>
          </div>
          <div className="credential-card-islands">
            <div className="credential-nike-logo">
              <svg viewBox="0 0 69 32" className="nike-logo-credential">
                <path
                  fill="currentColor"
                  d="M68.56 4L18.4 25.36Q12.16 28 7.92 28q-4.8 0-6.96-3.36-1.36-2.16-.8-5.48t2.96-7.08q2-3.04 6.56-8-1.6 2.56-2.24 5.28-1.2 5.12 2.4 7.52Q14.24 19 21.52 19q4.4 0 16.64-3.52L68.56 4z"
                />
              </svg>
            </div>
            <div className="credential-info">
              <div className="credential-title">Nike</div>
              <div className="credential-subtitle">Senior Software Engineer</div>
            </div>
          </div>
          <div className="credential-card-islands">
            <div className="credential-icon-islands">
              <GraduationCapIcon />
            </div>
            <div className="credential-info">
              <div className="credential-title">MIT</div>
              <div className="credential-subtitle">Post-Graduate Degree • Full-Stack Dev</div>
            </div>
          </div>

          <div className="credential-card-islands">
            <div className="credential-icon-islands">
              <InstitutionIcon />
            </div>
            <div className="credential-info">
              <div className="credential-title">Illinois Institute of Technology</div>
              <div className="credential-subtitle">M.S. Information Technology</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  )
})
